<template>
    <div>
        <Breadcrumb section-name="Expense" :breadcrumb="breadCrumb" :btn-name="'Add '+ breadCrumb"
                    :click-action="expenseAdd"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body">
                    <Table :tbl-data="table" :param="param"></Table>
                </div>
            </div>
        </div>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    </div>
</template>

<script>
import Breadcrumb from "../Common/Breadcrumb";
import ApiService from "../../Services/ApiService";
import PrintService from "../../Services/PrintService";
import ApiRoutes from "../../Services/ApiRoutes";
import Table from "../Common/Table";
import DownloadService from "../../Services/DownloadService";
import ConfirmDialogue from "../Common/confirmPopup/ConfirmDialogue";
import dayjs from "dayjs";
export default {
    components: {Table, Breadcrumb, ConfirmDialogue},
    data() {
        return {
            breadCrumb: [],
            param: {
                keyword: '',
                limit: 10,
                order_by: 'id',
                order_mode: 'DESC',
                page: 1,
                start_date: '',
                end_date: '',
                project_id: '',
                expense_category_id: '',
                payment_method: '',
                raw_material_id: '',
                supplier_id: ''
            },
            table: {
                columns: [
                    {type: 'text', key: 'date', label: 'Date', sortable: true},
                    {type: 'text', key: 'project_name', label: 'Project', photo: true, sortable: true},
                    {type: 'text', key: 'payment_method', label: 'Payment Method', sortable: true},
                    {type: 'text', key: 'expense_category_name', label: 'Expense Category', sortable: true},
                    {type: 'text', key: 'raw_material_name', label: 'Raw Material', sortable: true},
                    {type: 'text', key: 'purchase_by', label: 'Purchase By', sortable: true},
                    {type: 'text', key: 'supplier_name', label: 'Supplier Name', sortable: true},
                    {type: 'text', key: 'special_expense_name', label: 'Special Expense', sortable: true},
                    {type: 'text', key: 'construction_name', label: 'Construction', sortable: true},
                    {type: 'text', key: 'remarks', label: 'Remarks', sortable: true},
                    {type: 'text', key: 'amount', label: 'Amount', sortable: true},
                ],
                rows: [],
                row_actions: [
                    {name: 'print', type: 'action', label: 'bx bx-printer', color: 'btn-primary', loading: false},
                    {name: 'edit', type: 'action', label: 'bx bx-pencil', color: 'btn-info'},
                    {name: 'delete', type: 'action', label: 'bx bx-trash', color: 'btn-gradient-danger'}
                ],
                tableIconAction: (data) => {
                    this.tableIconAction(data.row_action, data.row_data, data.row_index);
                },
                tableLoading: false,
                paginateData: {},
                updatePagination: (page) => {
                    this.list(page)
                },
                updateFilter: (param) => {
                    this.param = param
                    this.list()
                },
                dateSearch: {
                    selectedDate: '',
                    mode: 'range',
                    action: (event) => {
                        if (event.length > 1) {
                            this.param.start_date = dayjs(event[0]).format('YYYY-MM-DD')
                            this.param.end_date = dayjs(event[1]).format('YYYY-MM-DD')
                            this.list()
                        }
                    }
                },
                dropdown: [
                    {
                        title: 'All Project',
                        data: [],
                        action: (event) => {
                            this.param.project_id = event.target.value
                            this.list()
                        }
                    },
                    {
                        title: 'All Category',
                        data: [],
                        action: (event) => {
                            this.param.expense_category_id = event.target.value
                            this.list()
                        }
                    },
                    {
                        title: 'All Payment Method',
                        data: [],
                        action: (event) => {
                            this.param.payment_method = event.target.value
                            this.list()
                        }
                    },
                    {
                        title: 'All Raw Material',
                        data: [],
                        action: (event) => {
                            this.param.raw_material_id = event.target.value
                            this.list()
                        }
                    },
                    {
                        title: 'All Supplier',
                        data: [],
                        action: (event) => {
                            this.param.supplier_id = event.target.value
                            this.list()
                        }
                    },
                    {
                        title: 'Purchase By',
                        data: [],
                        action: (event) => {
                            this.param.purchase_by = event.target.value
                            this.list()
                        }
                    },
                ],
                download: [
                    {
                        icon: 'pdf',
                        loading: false,
                        action: () => {
                            this.downloadFile('pdf')
                        }
                    }
                ],
                noDataError: ' Please click "+ Add Expense" to add a new Expense',
                total: {
                    colspan: 10,
                    amount: ''
                }
            },
            id: []
        }
    },
    watch: {

    },
    methods: {
        fetchPurchaseBy() {
            ApiService.POST(ApiRoutes.ShareHolder + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.table.dropdown[5].data = res.data.data;
                }
            });
        },
        fetchSupplier: function() {
            ApiService.POST(ApiRoutes.Supplier + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.table.dropdown[4].data = res.data.data;
                }
            });
        },
        fetchRawMaterial: function() {
            ApiService.POST(ApiRoutes.RawMaterial + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.table.dropdown[3].data = res.data.data;
                }
            });
        },
        fetchAsset: function() {
            ApiService.POST(ApiRoutes.Asset + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.table.dropdown[2].data = res.data
                }
            });
        },
        fetchCategory: function() {
            ApiService.POST(ApiRoutes.ExpenseCategory + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.table.dropdown[1].data = res.data.data
                }
            });
        },
        fetchProject: function() {
            ApiService.POST(ApiRoutes.Project + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.table.dropdown[0].data = res.data.data
                }
            });
        },
        expenseAdd() {
            this.$router.push({
                name: 'expenseAdd'
            })
        },
        async tableIconAction (type, data, index = null) {
            this.id = this.structureReturnData(data)
            if (type === 'edit') {
                const url = this.$router.resolve({
                    name: 'expenseEdit',
                    params: { id: data.id }
                }).href
                window.open(url, '_blank')
            } else if (type === 'view') {
                this.$router.push({
                    name: 'shareholderView',
                    params: { id: data.id }
                })
            } else if (type === 'delete') {
                const ok = await this.$refs.confirmDialogue.show({
                    title: 'Delete Expense',
                    message: 'Are you sure you want to delete this Expense?',
                    okButton: 'Delete',
                })
                if (ok) {
                    this.delete()
                }
            } else if (type === 'print') {
                if (index != null) {
                    PrintService.print('/expense/print/' + data.id);
                }
            }
        },

        list: function (page) {
            if (page === undefined) {
                page = 1
            }
            this.param.page = page;
            this.table.loading = true
            ApiService.POST(ApiRoutes.Expense + '/list', this.param, (res) => {
                this.table.loading = false
                if (parseInt(res.status) === 200) {
                    this.table.rows = res.data.data.data;
                    this.table.paginateData = res.data.data;
                    this.table.total.amount = res.data.total;
                }
            });
        },
        delete: function () {
            ApiService.POST(ApiRoutes.Expense + '/delete', {id: this.id[0]}, (res) => {
                this.$refs.confirmDialogue._loading(false)
                if (parseInt(res.status) === 200) {
                    this.$toast.success(res.message)
                    this.$refs.confirmDialogue._hide()
                    this.list()
                }
            });
        },
        downloadFile: function (type) {
            let route = type === 'xls' ? ApiRoutes.Expense + '/export/excel' : ApiRoutes.Expense + '/export/pdf'
            let name = type === 'xls' ? 'Expense.xlsx' : 'Expense.pdf'
            DownloadService.download(route, this.table.download, name, type, this.param)
        }
    },
    mounted() {
        this.list()
        this.fetchProject();
        this.fetchCategory();
        this.fetchAsset();
        this.fetchRawMaterial();
        this.fetchSupplier();
        this.fetchPurchaseBy();
    },
    created() {
        this.breadCrumb.push(this.$route.name)
    }
}
</script>

<style scoped>

</style>
